import React from 'react';
import '../main.css';

import mainFacility from '../images/mainFacility.jpeg'; // Banner image
import LAB1 from '../images/LAB1.jpeg';
import LIBRARY1 from '../images/LIBRARY1.jpeg';
import LIBRARY3 from '../images/LIBRARY3.jpeg';
import LIBRARY4 from '../images/LIBRARY4.jpeg';
import tennis1 from '../images/tennis1.jpeg'; // Replace with your actual image if different

function HighSchoolFacilities() {
  const bannerStyle = {
    width: '100%',
    height: '600px',
    backgroundImage: `url(${mainFacility})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center 85%',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
  };

  return (
    <div style={{ backgroundColor: '#7494b4ff' }}>
      <div className="container-fluid px-0">

        {/* Banner */}
        <div style={bannerStyle}>
<h1
  style={{
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: '20px 40px',
    borderRadius: '10px',
    fontSize: '2.5rem',
    color: '#7494b4ff', // Added color here
  }}
>
  OUR FACILITIES
</h1>

        </div>

        {/* Holistic education note */}
        <div className="container my-4">
          <p className="lead text-center">
            At Highlands High School, we strive to provide a well-rounded education
            that nurtures academic excellence, creativity, physical development,
            and digital fluency — preparing every learner for a rapidly changing
            future.
          </p>
        </div>

        {/* Library Section */}
        <div className="container mb-5">

          {/* Full-width library image with full visibility */}
          <div className="row mb-3">
            <div className="col-md-12">
              <div
                style={{
                  width: '100%',
                  height: '500px',
                  backgroundColor: '#7494b4ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                className="rounded shadow-sm"
              >
                <img
                  src={LIBRARY1}
                  alt="Library View 1"
                  style={{
                    maxHeight: '100%',
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>
            </div>
          </div>

          {/* Library Title */}
          <h2 className="mb-4 text-center" style={{ textTransform: 'uppercase' }}>
            School Library
          </h2>

          {/* Library paragraph */}
          <div className="mb-4">
            <p style={{ fontSize: '1.125rem', lineHeight: '1.6' }}>
              Our school library is more than just a place to borrow books — it's a vibrant hub where curiosity blossoms and lifelong learning begins.
              Here, students of all ages discover new worlds, develop critical thinking skills, and ignite their passions through a rich collection of resources.
              We encourage every student and parent to see the library as a cornerstone of our educational journey, where knowledge meets inspiration in a welcoming and supportive space.
              Together, we prepare our learners to confidently face the challenges of tomorrow by fostering a love for reading, inquiry, and collaboration.
            </p>
          </div>

          {/* Library Image and Text */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <img
                src={LIBRARY3}
                alt="Library View 3"
                className="img-fluid rounded shadow-sm mb-3"
              />
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Designed for comfort and focused study, our library’s reading areas and technology zones support both independent learning and group collaboration.
                Whether students are diving into research or simply enjoying a good book, they’ll find the resources and environment they need to thrive.
              </p>
            </div>

            <div className="col-md-6 mb-3 d-flex align-items-center">
              <img
                src={LIBRARY4}
                alt="Library View 4"
                className="img-fluid rounded shadow-sm w-100"
              />
            </div>
          </div>
        </div>

        {/* Computer Lab Section */}
        <div className="container mb-5">
          <h2 className="mb-3 text-center" style={{ textTransform: 'uppercase' }}>
            Computer Lab
          </h2>
          <div className="row align-items-center">
            <div className="col-md-6">
              <img
                src={LAB1}
                alt="Computer Lab 1"
                className="img-fluid rounded"
              />
            </div>
            <div className="col-md-6">
              <p style={{ fontSize: '1.125rem', lineHeight: '1.6' }}>
                Our newly upgraded computer labs provide students with access to modern technology in a dynamic and interactive environment.
                Equipped with high-speed internet and up-to-date software, these labs support learning in coding, research, design, and digital literacy.
                The new LAN system ensures reliable performance for class activities, assessments, and digital collaboration. Students gain hands-on experience with the tools shaping the future.
              </p>
            </div>
          </div>
        </div>

        {/* Sports Section */}
        <div className="container mb-5">
          <h2 className="mb-3 text-center" style={{ textTransform: 'uppercase' }}>
            Sports
          </h2>
          <div className="row align-items-center">
            <div className="col-md-6">
              <p style={{ fontSize: '1.125rem', lineHeight: '1.6' }}>
                We promote sports and activeness by providing opportunities in soccer, tennis, basketball, and more.
                Our sports facilities and coaching staff encourage students to develop teamwork, discipline, and healthy lifestyles through competitive and recreational activities.
              </p>
            </div>
            <div className="col-md-6">
              <img
                src={tennis1}
                alt="Tennis court"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>

        {/* Bottom image row */}
        <div className="container mb-5">
          <div className="row mt-4">
          </div>
        </div>
      </div>
    </div>
  );
}

export default HighSchoolFacilities;
